import { render, staticRenderFns } from "./tt_detail.vue?vue&type=template&id=c327de94&"
import script from "./tt_detail.vue?vue&type=script&lang=js&"
export * from "./tt_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports